import React from 'react';
import { Globe } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../contexts/LanguageContext';
import { content } from '../mock';
import { resolveLocalizedText } from '../lib/i18n';

export const Header = ({ propertyName, showLanguageToggle = true }) => {
  const { language, toggleLanguage } = useLanguage();
  const t = content[language];

  // Use provided property name or fallback to mock data
  const displayName = resolveLocalizedText(propertyName, language) || t.propertyName;

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white/80 backdrop-blur-md">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center">
            <h1 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent">
              {displayName}
            </h1>
          </div>
          
          {showLanguageToggle && (
            <Button
              variant="outline"
              size="sm"
              onClick={toggleLanguage}
              className="flex items-center gap-2 hover:bg-teal-50 transition-colors"
            >
              <Globe className="h-4 w-4" />
              <span className="hidden sm:inline">{language === 'es' ? 'English' : 'Español'}</span>
              <span className="sm:hidden">{language === 'es' ? 'EN' : 'ES'}</span>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};
